import styled from "@emotion/styled";
import { space } from "@smartsheet/design-tokens";
import { toastTheme } from "./toastTheme";
export const ToastActionsStyled = styled("div")`
    display: inline-flex;
    align-items: center;
    margin: ${space.space20} ${space.space20} 0 0;

    gap: ${_ref => {
  let {
    themeMode
  } = _ref;
  return toastTheme.actionButton.gap(themeMode);
}};
`;
//# sourceMappingURL=ToastActionsStyled.js.map